// src/components/SplashScreen.js
import { useEffect } from "react";
import { Box } from "@mui/material";

const SplashScreen = ({ onFinish }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish();
    }, 2000); // 2 detik

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "background.default",
      }}
    >
      <Box
        component="img"
        src="/logo/logo_splash_removed.png" // Sesuaikan dengan path logo Anda
        alt="Logo"
        sx={{
          width: 250,
          height: 250,
          mb: 3,
          animation: "pulse 2s infinite",
          "@keyframes pulse": {
            "0%": { transform: "scale(1)" },
            "50%": { transform: "scale(1.05)" },
            "100%": { transform: "scale(1)" },
          },
        }}
      />
    </Box>
  );
};

export default SplashScreen;
